/* ==========================================================================
   Kuba PDP — carrossel horizontal (.kb-hs) no mobile.
   Alinha a primeira coluna à grade, marca o wrapper e cria setas de verdade
   (a indicação anterior era só visual e o clique passava pro card de trás).
   Vanilla JS, idempotente (o editor de temas recarrega seções).
   ========================================================================== */
(function () {
  'use strict';
  if (window.__kbHsLoaded) { window.__kbHsInit && window.__kbHsInit(); return; }
  window.__kbHsLoaded = true;

  function setup(sc) {
    if (sc.__kbHs) return;
    var w = sc.parentElement;
    if (!w) return;
    sc.__kbHs = true;
    w.classList.add('kb-hsw');

    var upd = function () {
      var max = sc.scrollWidth - sc.clientWidth;
      w.setAttribute('data-hs-on', max > 12 ? '1' : '0');
      w.setAttribute('data-hs-end', max - sc.scrollLeft > 12 ? '0' : '1');
      w.setAttribute('data-hs-start', sc.scrollLeft > 12 ? '0' : '1');
    };

    var make = function (dir) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'kb-hsw__btn kb-hsw__btn--' + dir;
      b.setAttribute('aria-label', dir === 'next' ? 'Ver mais' : 'Voltar');
      b.textContent = dir === 'next' ? '→' : '←';
      b.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var step = Math.max(160, Math.round(sc.clientWidth * 0.8));
        var left = dir === 'next' ? step : -step;
        if (sc.scrollBy) sc.scrollBy({ left: left, behavior: 'smooth' });
        else sc.scrollLeft = sc.scrollLeft + left;
        setTimeout(upd, 450);
      });
      return b;
    };

    w.appendChild(make('next'));
    w.appendChild(make('prev'));
    sc.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd);
    if (window.ResizeObserver) { new window.ResizeObserver(upd).observe(sc); }
    upd();
  }

  function init() {
    document.querySelectorAll('.kb-hs').forEach(setup);
  }
  window.__kbHsInit = init;

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', init);
  document.addEventListener('shopify:section:load', function () { setTimeout(init, 50); });
})();
